import React, { useRef, useState, useEffect, useMemo, useCallback } from "react";
import { motion } from "framer-motion";
import { render } from "react-dom";
import Footer from "../Footer/Footer";
import GLOBALS from "../../utils/Globals";
//import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfileAction } from "../../redux/slices/users/usersSlice";
import { Alert, Spinner, Button } from "react-bootstrap";
import { FaTriangleExclamation, FaWifi } from "react-icons/fa6";
import { MdRefresh } from "react-icons/md";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { CellClickedEvent } from "ag-grid-community";
import "../AgGrid/styles.css";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import "./style.css";
import logo from "../../assets/img/verified-barcode.svg"
import {
  LicenseManager,
  RowApiModule,
  HighlightChangesModule,
  ValidationModule,
} from "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid
import "ag-grid-community/styles/ag-theme-material.css";
import ButtonRendererSearch from "../AgGrid/ButtonRendererSearch";

function GlnSearch() {

    const[state, setState] = useState({
      isPaneOpen: false,
      isPaneOpenLeft: false,
    });

    const [gtins, setGtins] = React.useState(null);
    const [searchLoading, setSearchLoading] = React.useState(false);
    const [searchError, setSearchError] = React.useState(null);

    const [gtin, setGtin] = React.useState(null);
    const [gtinStatus, setGtinStatus] = React.useState(null);

    const [licenceType, setLicenseType] = React.useState(null);
    const [gln, setGln] = React.useState(null);

    const [licenseeName, setLicenseeName] = React.useState(null);
    const [dateCreated, setDateCreated] = React.useState(null);
    const [dateUpdated, setDateUpdated] = React.useState(null);

    const [licenceKey, setLicenceKey] = React.useState(null);
    const [countryCode, setCountryCode] = React.useState(null);

    const gridRef = useRef();
    const [rowData, setRowData] = useState();

    const baseURLGetGLNS =
      process.env.REACT_APP_ENV === "PROD"
        ? GLOBALS.PROD.baseURLGetGLNS
        : GLOBALS.DEV.baseURLGetGLNS;

          const gridOptions = {
            autoSizeStrategy: {
              type: "fitCellContents",
            },
          };

          const [colDefs, setColDefs] = useState([
            // {
            //   field: "line",
            //   flex: 1,
            // },
            {
              field: "gln",
              filter: "agTextColumnFilter",
              headerName: "GLN",
              //cellRenderer: ClickableCellRenderer,
            },
            {
              field: "licenceType",
              filter: "agTextColumnFilter",
              headerName: "License Type",
            },
            {
              field: "licenseeName",
              filter: "agTextColumnFilter",
              headerName: "Licensee Name",
            },
            {
              field: "licenceStatus",
              headerName: "Status",
              cellClassRules: {
                "red-cell": (p) => p.value === "failed",
                "green-cell": (p) => p.value === "Active",
              },
              filter: "agTextColumnFilter",
            },
            // {
            //   field: "actions",
            //   headerName: "Actions",
            //   cellRenderer: ButtonRendererSearch,
            // },
          ]);

            const rowSelection = useMemo(() => {
              return {
                mode: "singleRow",
                checkboxes: false,
              };
            }, []);

  const [formData, setFormData] = useState({
    //fullname: "",
    //organization: "",
    //email: "",
    //phone: "",
    subject: "",
    message: "",
  });

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUserProfileAction());
  }, [dispatch]);
  const { error, loading, profile } = useSelector((state) => state?.users);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const glnValue = e.target[0].value;
    console.log(glnValue);

    try {
      setSearchLoading(true);
      setSearchError(null);
      setGtins(null); // Clear previous results

      console.log(baseURLGetGLNS + "/" + glnValue);
      const response = await axios.get(baseURLGetGLNS + "/" + glnValue);

      // handle the response
      setGtins(response.data);
      console.log(response.data);
    } catch (err) {
      // Handle different types of errors
      let errorMessage = 'Failed to search GLN. Please try again.';
      let errorType = 'general';

      if (err.code === 'ERR_NETWORK' || err.message.includes('ERR_CONNECTION_REFUSED')) {
        errorMessage = 'Unable to connect to the GLN service. Please check your internet connection and try again.';
        errorType = 'connection';
        console.error("GLN search connection error:", err);
      } else if (err.code === 'ECONNREFUSED' || err.message.includes('ECONNREFUSED')) {
        errorMessage = 'The GLN service is currently unavailable. Please try again in a few moments.';
        errorType = 'connection';
        console.error("GLN search service unavailable:", err);
      } else if (err.response?.status === 404) {
        errorMessage = `GLN "${glnValue}" was not found in the GS1 Global Location Number database. Please verify the GLN number and try again.`;
        errorType = 'notfound';
        // Don't log 404 as an error - it's a normal "not found" response
        console.info(`GLN ${glnValue} not found in GS1 database`);
      } else if (err.response?.status >= 500) {
        errorMessage = 'Server error occurred during GLN search. Please try again later.';
        errorType = 'server';
        console.error("GLN search server error:", err);
      } else if (err.response?.status === 401 || err.response?.status === 403) {
        errorMessage = 'Access denied for GLN search. Please check your permissions.';
        errorType = 'auth';
        console.error("GLN search authentication error:", err);
      } else if (err.response?.status === 400) {
        // Check if this is an enhanced error response with helpful information
        const responseData = err.response?.data;
        if (responseData?.converted_from_gtin && responseData?.helpful_message) {
          errorMessage = responseData.helpful_message;
          if (responseData.suggestion) {
            errorMessage += ` ${responseData.suggestion}`;
          }
          errorType = 'gtin_conversion';
          console.info(`GLN search: GTIN conversion attempted - ${responseData.original_input} → ${responseData.converted_gln}`, responseData);
        } else {
          errorMessage = 'Invalid GLN format. Please check the GLN number and try again.';
          errorType = 'validation';
          console.error("GLN search validation error:", err);
        }
      } else {
        // Only log unexpected errors
        console.error("Unexpected GLN search error:", err);
      }

      setSearchError({ message: errorMessage, type: errorType, originalError: err, gln: glnValue });
    } finally {
      setSearchLoading(false);
    }
  };

  const handleRetrySearch = () => {
    if (searchError?.gln) {
      // Retry with the same GLN that failed
      const fakeEvent = {
        preventDefault: () => {},
        target: [{ value: searchError.gln }]
      };
      handleSubmit(fakeEvent);
    }
  };

    const updateRows = useCallback((gtin, row) => {
      const rowNode = gridRef.current.api.getDisplayedRowAtIndex(row);

      //console.log(rowNode)

      if (gtin == "its null") {
        rowNode.setDataValue("status", "failed");
      }
      if (rowNode.data.GTIN == gtin) {
        rowNode.setDataValue("status", "success");
      }

      //console.log(rowNode);
    }, []);

    const defaultColDef = useMemo(() => {
      return {
        flex: 1,
        editable: false,
        enableCellChangeFlash: true,
      };
    });

     const onCellClicked = useCallback((event) => {
       console.log(event.data.gtin);

       console.log(event.data.licenseeGLN);
       console.log(event.data.licenceType);

       setGln(event.data.gln);
       setGtinStatus(event.data.gtinRecordStatus);

       setLicenseType(event.data.licenceType);
       setGln(event.data.gln);

       setLicenseeName(event.data.licenseeName);
       setDateCreated(event.data.dateCreated);
       setDateUpdated(event.data.dateUpdated);

       setCountryCode(event.data.address.countryCode);
       setLicenceKey(event.data.licenceKey);

       // Access the clicked cell's data and column definition
       setState({ isPaneOpen: true });
       const clickedRowData = event.data;
       const clickedColumn = event.colDef;
     }, []);

  // Show profile error if it exists
  if (error) {
    return (
      <>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="bg-sky-50 py-12"
        >
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ translateY: 20, opacity: 0 }}
              animate={{ translateY: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <h1 className="text-3xl font-bold text-gray-900 mb-3">
                GLN Search
              </h1>
              <p className="text-gray-600 mb-6">
                Please enter in a GLN number; this tool searches for one GLN at a
                time
              </p>
            </motion.div>

            <Alert variant="danger" className="d-flex align-items-center">
              <FaTriangleExclamation className="me-3" size={24} />
              <div className="flex-grow-1">
                <h5 className="alert-heading mb-2">Profile Loading Error</h5>
                <p className="mb-2">
                  Unable to load your profile information. This may be due to a connection issue or you may need to log in again.
                </p>
                <div className="small text-muted mb-3">
                  <FaWifi className="me-1" />
                  Please check your internet connection and try refreshing the page.
                </div>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => window.location.reload()}
                >
                  <MdRefresh className="me-1" />
                  Refresh Page
                </Button>
              </div>
            </Alert>
            <Footer />
          </div>
        </motion.div>
      </>
    );
  }

  // Show loading state for profile
  if (loading) {
    return (
      <>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="bg-sky-50 py-12"
        >
          <div className="container mx-auto px-4">
            <motion.div
              initial={{ translateY: 20, opacity: 0 }}
              animate={{ translateY: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <h1 className="text-3xl font-bold text-gray-900 mb-3">
                GLN Search
              </h1>
              <p className="text-gray-600 mb-6">
                Please enter in a GLN number; this tool searches for one GLN at a
                time
              </p>
            </motion.div>

            <div className="text-center py-12">
              <Spinner animation="border" role="status" className="mb-3" size="lg">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
              <p className="text-gray-600">Loading your profile...</p>
            </div>
            <Footer />
          </div>
        </motion.div>
      </>
    );
  }

  return (
    <>
      {/* <button onClick={() => setState({ isPaneOpen: true })}>
        Click me to open right pane!
      </button> */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="bg-sky-50 py-12"
      >
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ translateY: 20, opacity: 0 }}
            animate={{ translateY: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h1 className="text-3xl font-bold text-gray-900 mb-3">
              GLN Search
            </h1>
            <p className="text-gray-600 mb-6">
              Please enter in a GLN number; this tool searches for one GLN at a
              time
            </p>
          </motion.div>

          <motion.form
            onSubmit={handleSubmit}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="bg-white shadow-md rounded-xl p-6 space-y-4"
          >
            <div className="grid md:grid-cols-2 gap-4">
              <motion.div
                whileFocus={{ scale: 1.02 }}
                className="col-span-full relative"
              >
                <input
                  type="text"
                  id="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                  placeholder="GLN Number"
                  required
                />
              </motion.div>
            </div>
            <br></br>
            <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <button
                type="submit"
                disabled={searchLoading}
                className="w-full bg-sky-500 text-white py-3 rounded-lg hover:bg-sky-600 transition duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {searchLoading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Searching...
                  </>
                ) : (
                  'Search'
                )}
              </button>
              <br></br>
              <br></br>
            </motion.div>

            {/* Error Display */}
            {searchError && (
              <Alert variant="danger" className="d-flex align-items-center">
                <FaTriangleExclamation className="me-3" size={24} />
                <div className="flex-grow-1">
                  <h6 className="alert-heading mb-2">Search Error</h6>
                  <p className="mb-2">{searchError.message}</p>
                  {searchError.type === 'connection' && (
                    <div className="small text-muted mb-3">
                      <FaWifi className="me-1" />
                      This usually indicates a network connectivity issue or the GLN service is temporarily unavailable.
                    </div>
                  )}
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={handleRetrySearch}
                    disabled={searchLoading}
                  >
                    {searchLoading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Retrying...
                      </>
                    ) : (
                      <>
                        <MdRefresh className="me-1" />
                        Try Again
                      </>
                    )}
                  </Button>
                </div>
              </Alert>
            )}
            {gtins && (
              <>
                <h1>Search Results - click for more details</h1>
                {gtins.length === 0 ? (
                  <Alert variant="info" className="text-center">
                    <h5>No GLN Results Found</h5>
                    <p className="mb-0">No GLNs were found matching your search criteria. Please check the GLN number and try again.</p>
                  </Alert>
                ) : (
                  <div
                    className="ag-theme-material" // applying the Data Grid theme
                    style={{ height: 800 }}
                  >
                    <AgGridReact
                      ref={gridRef}
                      rowData={gtins}
                      gridOptions={gridOptions}
                      animateRows={true}
                      columnDefs={colDefs}
                      rowSelection={rowSelection}
                      pagination={true}
                      paginationPageSize={10}
                      paginationPageSizeSelector={[10, 20]}
                      defaultColDef={defaultColDef}
                      onCellClicked={onCellClicked}
                      frameworkComponents={{
                        ButtonRendererSearch: ButtonRendererSearch,
                      }}
                      //onCellValueChanged={onCellValueChanged}
                    />
                  </div>
                )}
              </>
            )}
          </motion.form>
          <br></br>
          <br></br>
          <Footer />
        </div>
      </motion.div>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={state.isPaneOpen}
        title="GLN Details"
        onRequestClose={() => {
          // triggered on "<" on left top click or on outside click
          setState({ isPaneOpen: false });
        }}
      >
        <img
          className="h-8 sm:h-10 lg:h-14 w-auto object-contain"
          src={logo}
          alt="GS1 logo"
        />
        <br />
        <div>GLN Details</div>
        <motion.form
          onSubmit={handleSubmit}
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="bg-white shadow-md rounded-xl p-6 space-y-4"
        >
          <div className="grid md:grid-cols-2 gap-4">
            <motion.div
              whileFocus={{ scale: 1.02 }}
              className="col-span-full relative"
            >
              <label>
                GLN:
                <input
                  type="text"
                  id="gln"
                  value={gln}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                  placeholder="GLN"
                  required
                />
              </label>
              <br></br>
              <label>
                GTIN Type:
                <input
                  type="text"
                  id="licenseType"
                  value={licenceType}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                  placeholder="GTIN Type"
                  required
                />
              </label>
              <br></br>
              <label>
                Licensee Name:
                <input
                  type="text"
                  id="licenseeName"
                  value={licenseeName}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                  placeholder="Licensee Name"
                  required
                />
              </label>

              <br></br>
              <label>
                Date Created:
                <input
                  type="text"
                  id="dateCreated"
                  value={dateCreated}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                  placeholder="Date Created"
                  required
                />
              </label>
              <br></br>
              <label>
                Date Updated:
                <input
                  type="text"
                  id="dateUpdated"
                  value={dateUpdated}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                  placeholder="Data Updated"
                  required
                />
              </label>
              <br></br>
              <label>
                Country Code:
                <input
                  type="text"
                  id="countryCode"
                  value={countryCode}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                  placeholder="Country Code"
                  required
                />
              </label>
              <br></br>
              <label>
                License Key:
                <input
                  type="text"
                  id="licenceKey"
                  value={licenceKey}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-sky-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 transition"
                  placeholder="License Key"
                  required
                />
              </label>
            </motion.div>
          </div>
        </motion.form>
      </SlidingPane>
    </>
  );
}

export default GlnSearch;
